var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$apollo.loading)?_c('div',[_c('v-progress-linear',{attrs:{"indeterminate":"","color":"primary"}})],1):_vm._e(),(!_vm.$apollo.loading)?_c('div',{staticClass:"chart-container"},[_c('highcharts',{ref:"chart",attrs:{"options":_vm.callsByDayChart}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }